module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_sakura-d806c9dd9737ce152b65460c43dbb3b4.png";